import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login(){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password); // this works for both email and username
      nav('/');
    } catch (err) {
      alert('Login failed: ' + (err?.message || err));
    }
  };

  return (
    <div className="login-layout">
      
      {/* LEFT */}
      <div className="login-left">
        <div className="login-overlay">
          <div className="login-logo">
            <img src="https://myfavv.live/wp-admin/images/Logo/myFAVV.png" alt="myFAVV Logo" />
          </div>
          <h1>Welcome to myFAVV</h1>
          <p>Connect. Create. Grow your super social world.</p> 
        </div>
      </div>

      {/* RIGHT */}
      <div className="login-right">
        <div className="page auth">
          <h2>Login</h2>
          <form onSubmit={submit}>
            <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" required />
            <input value={password} onChange={e=>setPassword(e.target.value)} type="password" placeholder="Password" required />
            <button type="submit">Login</button>
          </form>
          <p>Don't have account? <Link to="/signup">Signup</Link></p>
        </div>

        <div className="login-logo mobile-logo">
          <img src="https://myfavv.live/wp-admin/images/Logo/myFAVV.png" alt="myFAVV Logo" />
        </div>
      </div>

      {/* STYLES */}
      <style>{`
        .login-layout {
          min-height: 100vh;
          display: flex;
          background: #0b0f1a;
        }

        .login-left {
          flex: 1;
          background: url("https://images.unsplash.com/photo-1521737604893-d14cc237f11d") center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .login-left::before {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,.45);
          z-index: 0;
        }

        .login-overlay {
          padding: 60px;
          border-radius: 18px;
          color: #fff;
          text-align: center;
          z-index: 2;
          position: relative;
        }

        .login-logo {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          background: linear-gradient(135deg,#3b82f6,#ff4800);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 18px;
          box-shadow: 0 10px 30px rgba(0,0,0,.4);
          overflow: hidden;
        }

        .login-logo img {
          width: 70%;
          height: 70%;
          object-fit: contain;
        }

        .mobile-logo {
          display: none;
        }

        .login-overlay h1 {
          font-size: 3rem;
          margin-bottom: 14px;
        }

        .login-overlay p {
          font-size: 1.2rem;
          opacity: .9;
        }

        .login-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #0b0f1a;
        }

        .page.auth {
          width: 100%;
          max-width: 380px;
          background: rgba(255,255,255,.06);
          padding: 40px;
          border-radius: 18px;
          box-shadow: 0 20px 50px rgba(0,0,0,.5);
          backdrop-filter: blur(10px);
          color: #fff;
        }

        .page.auth h2 {
          margin-bottom: 20px;
          text-align: center;
        }

        .page.auth input {
          width: 100%;
          padding: 12px;
          margin-bottom: 14px;
          border-radius: 10px;
          border: none;
          outline: none;
        }

        .page.auth button {
          width: 100%;
          padding: 12px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(135deg,#3b82f6,#ff4800);
          color: #fff;
          font-weight: 600;
          cursor: pointer;
        }

        .page.auth p {
          margin-top: 14px;
          text-align: center;
        }

        .page.auth a {
          color: #3b82f6;
        }

        /* MOBILE */
        @media (max-width: 900px) {
          .login-layout {
            flex-direction: column;
          }

          .login-left {
            position: fixed;
            inset: 0;
            z-index: 1;
            align-items: flex-start;
            padding-top: 60px;
          }

          .login-overlay {
            padding: 0 20px;
          }

          .login-overlay h1 {
            font-size: 2.2rem;
          }

          .login-overlay p {
            font-size: 1rem;
          }

          .login-right {
            position: relative;
            z-index: 2;
            background: transparent;
            min-height: 100vh;
            justify-content: center;
            padding: 20px;
          }

          .page.auth {
            background: rgba(0,0,0,.65);
          }

          .login-logo {
            display: none;
          }

          .mobile-logo {
            display: flex;
            margin-top: 24px;
          }
        }
      `}</style>

    </div>
  );
}
